import { pickBy } from "lodash-es";
import shouldForwardProp from "@styled-system/should-forward-prop";

export function getDOMProps(props) {
  return pickBy(props, (_, propName) => shouldForwardProp(propName));
}
